export default "__VITE_ASSET__CKYZ22nd__"